import { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { PhoneCall, CheckCircle2 } from "lucide-react";
import { getAttributionPayload } from "../lib/attribution";
import { fireConversion, setEnhancedConversionData } from "../lib/tracking";
import { trackEvent } from "../lib/trackingClient";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// "Rückruf anfordern" Mini-Form -> speichert Lead (source: "rueckruf")
export default function CallbackForm() {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [consent, setConsent] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!name || !phone) return setError("Bitte Name und Telefon angeben.");
    if (!consent) return setError("Bitte stimmen Sie der Datenverarbeitung zu.");
    setLoading(true);
    try {
      await axios.post(`${API}/leads`, {
        name,
        phone,
        consent: true,
        source: "rueckruf",
        attribution: getAttributionPayload(),
      });
      await setEnhancedConversionData({ phone });
      fireConversion("rueckruf");
      trackEvent("rueckruf", { value: 50 });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.detail || "Es ist ein Fehler aufgetreten.");
    } finally {
      setLoading(false);
    }
  };

  const field =
    "w-full rounded-md border border-white/10 bg-[#0E0F12] px-3 py-2.5 text-sm text-white placeholder:text-gray-500 focus:border-[#3DDC97] focus:outline-none";

  if (done) {
    return (
      <div
        data-testid="callback-done"
        className="flex items-center gap-3 rounded-lg border border-[#3DDC97]/30 bg-[#3DDC97]/10 p-5 text-sm text-[#3DDC97]"
      >
        <CheckCircle2 size={20} /> Danke! Wir rufen Sie zeitnah zurück.
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="space-y-3" data-testid="callback-form">
      <div className="flex items-center gap-2 text-sm font-semibold text-white">
        <PhoneCall size={16} className="text-[#3DDC97]" /> Rückruf anfordern
      </div>
      <div className="grid gap-3 sm:grid-cols-2">
        <input data-testid="callback-name" className={field} placeholder="Ihr Name" value={name} onChange={(e) => setName(e.target.value)} />
        <input data-testid="callback-phone" className={field} placeholder="Telefonnummer" value={phone} onChange={(e) => setPhone(e.target.value)} />
      </div>
      <label className="flex items-start gap-2 text-xs text-gray-400">
        <input data-testid="callback-consent" type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} className="mt-0.5 accent-[#3DDC97]" />
        <span>
          Ich bin mit der Verarbeitung meiner Daten zur Kontaktaufnahme einverstanden.{" "}
          <Link to="/datenschutz" className="text-[#3DDC97] underline">Datenschutz</Link>.
        </span>
      </label>
      {error && <p data-testid="callback-error" className="text-sm text-red-400">{error}</p>}
      <button
        data-testid="callback-submit"
        type="submit"
        disabled={loading}
        className="w-full rounded-md bg-[#3DDC97] py-3 font-semibold text-[#0E0F12] transition-colors hover:bg-[#2BBF7E] disabled:opacity-50"
      >
        {loading ? "Wird gesendet …" : "Rückruf anfordern"}
      </button>
    </form>
  );
}
